import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/lib/auth";
import { Lock, Mail } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@kasimtrends.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-12 candy-dots" data-testid="admin-login-page">
      <form onSubmit={submit} className="nb-card p-7 md:p-9 w-full max-w-md bg-white">
        <div className="w-14 h-14 rounded-full bg-[var(--primary)] text-white border-[3px] border-black flex items-center justify-center mb-5 shadow-[3px_3px_0_0_#0A0A0A]">
          <Lock strokeWidth={2.5} />
        </div>
        <h1 className="font-display font-black uppercase text-3xl md:text-4xl mb-1">Admin Login</h1>
        <p className="text-black/70 mb-6">Sign in to manage products & campaigns.</p>

        <label className="block mb-3">
          <span className="text-sm font-black uppercase tracking-wider">Email</span>
          <div className="mt-1 flex items-center gap-2 border-[3px] border-black rounded-full bg-white px-4 py-2 shadow-[3px_3px_0_0_#0A0A0A]">
            <Mail size={18} strokeWidth={2.5} />
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              className="flex-1 outline-none bg-transparent" data-testid="admin-email-input" required
            />
          </div>
        </label>

        <label className="block mb-5">
          <span className="text-sm font-black uppercase tracking-wider">Password</span>
          <div className="mt-1 flex items-center gap-2 border-[3px] border-black rounded-full bg-white px-4 py-2 shadow-[3px_3px_0_0_#0A0A0A]">
            <Lock size={18} strokeWidth={2.5} />
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              className="flex-1 outline-none bg-transparent" data-testid="admin-password-input" required
            />
          </div>
        </label>

        <button type="submit" disabled={busy} data-testid="admin-login-submit"
          className="nb-btn bg-[var(--primary)] text-white w-full disabled:opacity-60">
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
